
export const BLOGS_ITEMS_PER_PAGE = 12;
export const TAGS_ITEMS_PER_PAGE = 30;

export const BLOG_STATE_DRAFT = "DRAFT";
export const BLOG_STATE_ACTIVE = "PUBLISHED";
export const BLOG_STATE_INACTIVE = "INACTIVE";
export const BLOG_TAB_TAGS = "Tags";
export const BLOG_TAG_MIN_LENGTH = 3;
export const MAX_TAGS_ALLOWED = 5;
export const MIN_CONTENT_NEEDED_IN_BLOGS = 3;

export const BLOG_CONTENT_KEY_PARAGRAPH = "paragraph";
export const BLOG_CONTENT_KEY_IMAGE = "image";
export const BLOG_CONTENT_KEY_LIST = "list";
export const BLOG_CONTENT_KEY_DELIMITER = "delimiter";
export const BLOG_CONTENT_KEY_FOCUS_ITEM = "focus";
export const BLOG_CONTENT_KEY_EMBED = "embed";
export const BLOG_CONTENT_KEY_TABLE = "table";
export const BLOG_CONTENT_KEY_HEADER = "header";

export const DEFAULT_BLOG_INITIAL_DATA = {
  "time": new Date().getTime(),
  "blocks": [

  ]
};

